import { TerritoryModel } from '@cpak/adp-cpak-accounts-service-models';
import { CountryConfigData } from '@cpak/adp-cpak-bff-service-models';
import { CountryDropdownItem } from '@cpak/interfaces';

export function getCountryList(
  countriesAndTerritories: TerritoryModel[],
  countryConfigs: CountryConfigData[]
): CountryDropdownItem[] {
  const countryIds = countriesAndTerritories.map(({ countryIds }) => countryIds).flat();
  const unsortedList = Array.from(new Set(countryIds)).map(countryCode => ({
    name: countryConfigs.find(value => value.id === countryCode)?.name || '',
    code: countryCode || '',
  }));
  return sortByName(unsortedList);
}

export function getTerritoryList(
  countriesAndTerritories: TerritoryModel[],
  countryCode: string
): CountryDropdownItem[] {
  const unsortedList =
    countriesAndTerritories
      .filter((territory: TerritoryModel) => territory.countryIds?.includes(countryCode))
      .map((territory: TerritoryModel) => ({
        name: territory.name || '',
        code: territory.id || '',
      })) || [];
  return sortByName(unsortedList);
}

export function sortByName<T>(entity: Array<T & { name: string }>): Array<T & { name: string }> {
  return [...entity].sort((prev, curr) => prev.name.localeCompare(curr.name));
}
